module.exports = __webpack_public_path__ + "static/media/history.aa1424d9.svg";